// Deterministic avatar color palette — shared by users and teams.
// Each identifier (name, email, or id) always maps to the same color.
const AVATAR_COLORS = [
  { from: "#7C3AED", to: "#4F46E5" }, // purple → indigo
  { from: "#2563EB", to: "#0EA5E9" }, // blue → sky
  { from: "#059669", to: "#0D9488" }, // emerald → teal
  { from: "#DC2626", to: "#DB2777" }, // red → pink
  { from: "#D97706", to: "#EA580C" }, // amber → orange
  { from: "#7C3AED", to: "#EC4899" }, // purple → pink
  { from: "#0891B2", to: "#2563EB" }, // cyan → blue
  { from: "#16A34A", to: "#15803D" }, // green shades
  { from: "#9333EA", to: "#7C3AED" }, // fuchsia → purple
  { from: "#B45309", to: "#D97706" }, // brown → amber
  { from: "#0F766E", to: "#059669" }, // teal → emerald
  { from: "#C2410C", to: "#D97706" }, // orange → amber
];

function hashString(str) {
  if (!str) return 0;
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

/** Darken a hex color by a factor (0–1). */
function darkenHex(hex, factor) {
  const r = Math.max(0, Math.round(parseInt(hex.slice(1, 3), 16) * (1 - factor)));
  const g = Math.max(0, Math.round(parseInt(hex.slice(3, 5), 16) * (1 - factor)));
  const b = Math.max(0, Math.round(parseInt(hex.slice(5, 7), 16) * (1 - factor)));
  return `#${[r, g, b].map(c => c.toString(16).padStart(2, "0")).join("")}`;
}

/**
 * Returns a deterministic gradient style object for an avatar.
 * Pass the user's name, email, or id — same input always yields the same color.
 *
 * If the org has set an avatar_color (exposed via CSS variable
 * `--org-avatar-color`), all avatars use that color as the gradient base.
 * Otherwise falls back to the deterministic palette. Callers don't need
 * to pass the org color — it's read automatically from the DOM.
 */
export function getAvatarStyle(identifier) {
  // Check for org-level avatar color override (set by OrgThemeContext)
  const orgColor = typeof document !== "undefined"
    ? getComputedStyle(document.documentElement).getPropertyValue("--org-avatar-color").trim()
    : "";
  if (orgColor && orgColor.startsWith("#")) {
    return {
      background: `linear-gradient(135deg, ${orgColor}, ${darkenHex(orgColor, 0.4)})`,
    };
  }
  const color = AVATAR_COLORS[hashString(identifier) % AVATAR_COLORS.length];
  return {
    background: `linear-gradient(135deg, ${color.from}, ${color.to})`,
  };
}
